import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface RoundImageContainerEntityParams {
  forward_state_name: string;
  forward_state_params: any;
  image_asset_url: string;
  text: string;
}
export class RoundImageContainerEntity extends BaseEntityClass {
  forward_state_name: string;
  forward_state_params: any;
  image_asset_url: string;
  text: string;
  constructor(params: RoundImageContainerEntityParams) {
    super();
    this.type = "round_image_container";
    this.entity_version = 2;
    this.forward_state_name = params.forward_state_name;
    this.forward_state_params = params.forward_state_params;
    this.image_asset_url = params.image_asset_url;
    this.text = params.text;
  }
}
